import { render, staticRenderFns } from "./Fill.vue?vue&type=template&id=c96ce37a&"
import script from "./Fill.vue?vue&type=script&lang=js&"
export * from "./Fill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/utils/fill/Fill.vue"
export default component.exports